export default __webpack_public_path__ + "static/media/referenzen_intro_web-md@1x.79162fb1.jpg";